<div class="modal-dialog-centered">
    <div class="container screenPos">
        <div class="container mt--8">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-7 cardPos">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="h3" style="text-align: center">REGISTER YOUR ETORO ACCOUNT 
                                <button type="button" placement="top" style="border: none; background-color: white;"
                                ngbPopover="Before registering with Backseat-Trader you must verify your existing eToro account first.">
                                <i class="fa-solid fa-circle-info"></i>
                        </button>                            </div>
                        </div>
                        <div class="card-body px-lg-5 py-lg-5">
                            <form [formGroup]="registerform" role="form" class="needs-validation" novalidate>

                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                                        </div>
                                        <input type="username" formControlName="username" class="form-control"
                                            placeholder="Username Verification" aria-describedby="inputGroupPrepend"
                                            style="height:5rem; 
                                            font-size:medium" required>
                                        <div class="input-group-append" style=" text-align: center">
                                            <button type="button" class="btn-primary text-center" (click)="verify()"
                                                style="padding-left:2rem; padding-right:2rem"
                                                *ngIf="!verifLoading && !success">
                                                <i class="fas fa-search text-white"></i>
                                            </button>
                                            <div class="spinner-border text-primary" role="status"
                                                *ngIf="verifLoading && !success"
                                                style="width: 3rem; height: 3rem; margin-left: 10px">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <div *ngIf="success">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fa fa-check fa-4x"
                                                            aria-hidden="true"
                                                            style="color: green; margin-bottom: 2px"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="!verifStatus" style="font-size:small">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        {{verifText}} <span *ngIf="counterExcess">({{theVerifCounter}})</span>
                                    </div>
                                    <div class="d-block" *ngIf="success" style="font-size:small; color: green">
                                        <i class="fa fa-check"></i> &nbsp;
                                        {{successText}}
                                    </div>
                                </div>
                                <br /><br />
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                        </div>
                                        <input type="email" formControlName="email" class="form-control"
                                            placeholder="Email" aria-describedby="inputGroupPrepend"
                                            style="height:5rem; font-size:medium" required>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="submitted && f.email.errors">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        Email is required
                                    </div>
                                </div>
                                <br /><br />
                                <div class="form-group">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-unlock"></i></span>
                                        </div>
                                        <input [type]="hide ? 'password' : 'text'" formControlName="password"
                                            class="form-control form-control-user" placeholder="Password"
                                            style="height:5rem; font-size:medium" required>
                                        <div class="input-group-append">
                                            <button type="button" class="btn-primary text-center" (click)="hide = !hide"
                                                style="padding-left:2rem; padding-right:2rem">
                                                <i *ngIf="!hide" class="fas fa-eye text-white"></i>
                                                <i *ngIf="hide" class="fas fa-eye-slash text-white"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="submitted && f.password.errors">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        Password is required
                                    </div>
                                </div>

                                <div *ngIf="error" class="alert alert-danger text-white" role="alert">
                                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                    Invalid credentials.
                                </div>

                                <div *ngIf="loading" class="text-center">
                                    <div class="spinner-grow text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <div class="theSpace">                                   
                                    <button type="button" [routerLink]="['/login']"
                                        class="btn btn-primary btn-lg btn-block">Login</button>
                                </div>
                                <div class="text-center">
                                    <button [hidden]="loading" (click)="register()" type="submit"
                                        class="btn btn-default btn-lg btn-block my-4">Register your eToro
                                        account</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">eToro Onboarding</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        Before you can register with Backseat-Trader, you must first have a registered <b>eToro username</b> - this will
        require you to go through the eToro onboarding process.
        <br />
        <br />
        Here is what to expect in eToro Onboarding:

        <ul>
            <li>Date of Birth</li>
            <li>Address</li>
            <li>Proof of Identity</li>
            <li>Tax Information</li>
            <li>Gauging of Trading Knowledge</li>
            <li>Mandatory Trading Quiz</li>
        </ul>
        <br />
        <h2><b>New to eToro - What you need to know:</b></h2>
        <br /><br />

        <br />
        <a (click)="close()">
            <div class="container">
                <div class="row align-items-start justify-content-center no-gutters">
                    <div class="col-md-auto">
                        <span class="hero__play js-play" target="_blank">
                            <img src="assets/img/svg/ico-play.svg" alt="">
                        </span>
                    </div>
                    <div class="col-md-auto">
                        <a [routerLink]="['/academy']">Video Academy - Overview</a>
                    </div>
                </div>
            </div>
        </a>
    </div>
</ng-template>